package app.nestbridge.feature.invitations.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.invitations.model.Invitation
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class InvitationListScreen(
    val _placeholder: Unit = Unit,
) : Screen

@Parcelize
data class InvitationListResult(
    val status: Status,
) : PopResult {
    enum class Status { Completed, Skipped, NoInvitations }
}

data class InvitationListState(
    val invitations: List<Invitation>,
    val isUserPartOfAnyTeam: Boolean,
    val eventSink: (InvitationListEvent) -> Unit,
) : CircuitUiState

sealed interface InvitationListEvent {
    data object OnAppear : InvitationListEvent
    data class OpenInvitation(val invitationId: String) : InvitationListEvent
    data object EnterCode : InvitationListEvent
    data object ScanQr : InvitationListEvent
    data object DecideLater : InvitationListEvent
}
